const OPEN_MODAL = 'OPEN_MODEL';
const CLOSE_MODAL = 'CLOSE_MODAL';

const initialState = {};

export const openModal = (payload = {}) => {
  return { type: OPEN_MODAL, payload };
};

export const closeModal = (payload = {}) => {
  return { type: CLOSE_MODAL, payload };
};

const modalReducer = (state = initialState, action) => {
  switch (action.type) {
    case OPEN_MODAL:
      return {
        ...state,
        ...action.payload,
      };
    case CLOSE_MODAL:
      return initialState;
    default:
      return state;
  }
};

export default modalReducer;
